module.exports = __webpack_public_path__ + "static/media/ic_arch.6ceb63a8.svg";